import api from '../../helpers/axios'

export const state = {
    dashboard: {},
};

export const getters = {
    dashboard: (state) => state.dashboard,
};

export const mutations = {
    setDashboard(state, newValue) {
        state.dashboard = newValue;
    },

};

export const actions = {
    fetchDashboard({ commit }) {
        return new Promise((resolve) => {
            api.get("/dashboard?page=1&limit=10&").then((res) => {
                commit("setDashboard", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
